/* eslint-disable no-shadow */
export const API_ERROR_TIMEOUT = 3000;
export const STALE_TIME = 30000;
export const RESEND_DISABLED_TIMEOUT = 5000;
export const API_ABORT_TIMEOUT = 1000 * 30;
export const API_ABORT_TIMEOUT_LONG = 1000 * 60;
export const BLOB_URL_REVOKE_DELAY_MS = 1000;
export const MOBILE_AUTH_TIMEOUT_MS = 1000;
export const EMPTY_STRING = '';
export const NOT_AVAILABLE = 'N/A';
export const LIVE_METRIC_THRESHOLD_GREEN = 75;
export const LIVE_METRIC_THRESHOLD_YELLOW = 90;
export const LIVE_METRIC_THRESHOLD_MAX = 100;
export const FULLSTOP = '.';
export const COMMA = ',';
export const SLASH = '/';
export const UNDERSCORE = '_';
export const WHITESPACE = ' ';
export const COLON = ':';
export const NUMBER = 'number';
export const TEXT = 'text';
export const PIPE = ' | ';
export const ASTERISK = '*';
export const HYPHEN = '-';
export const CHEVRON_RIGHT = '>';
export const SIGN_UP_DATA_STATE_KEY = 'signUpDataState';
export const ASSETRON_MARKETING_SITE_URL = 'https://assetron.ai';
export const TERMS_OF_SERVICES = `${ASSETRON_MARKETING_SITE_URL}/terms-of-service`;
export const PRIVACY_POLICY = `${ASSETRON_MARKETING_SITE_URL}/privacy`;
// eslint-disable-next-line no-secrets/no-secrets -- false positive: purpose enum, not a password
export const PASSWORD_RESET_PURPOSE = 'PasswordReset'; // NOSONAR
export const EMAIL_VERIFICATION_PURPOSE = 'EmailVerification';
export const USER_INVITE_PURPOSE = 'UserInvite';
export const ECONNABORTED = 'ECONNABORTED';
export const INVITE_DETAILS = 'inviteDetails';
export const INVITED_ORG_ID = 'invitedOrgId';
export const SHOULD_REQUEST_CUSTOM_TOKEN = 'shouldRequestCustomToken';
export const IS_HANDOVER_NOW = 'isHandoverNow';
export const DEFAULT_COUNTRY_CODE = 'us';
export const ASSET_TYPE_EXISTS = 'ASSET_TYPE_EXISTS';
export const DISPOSED = 'disposed';
export const ASSET_STATUS_AVAILABLE = 'Available';
export const FREE = 'Free';
export const INVALID_DATE = 'Invalid Date';
export const STRIPE_PLAN = 'STRIPE';
export const GPS = 'GPS';
export const IOS = 'IOS';
export const IAP = 'IAP';
export const REPORTS = 'reports';
export const PROFESSIONAL_STATUS = 'Professional';
export const ENTITLEMENT_TOKEN_EMPTY_ERROR_CODE = 'ENTITLEMENT_TOKEN_EMPTY';
export const TRANSITION_TIMEOUT_MS = 300;
export const DEFAULT_TOOLTIP_ENTER_DELAY = 300;
export const ALL_ASSETS_PATH = 'all-assets';
export const HUBS_PATH = 'hubs';
export const VIEWS_PATH = 'views';
export const ORG_ID_KEY = 'orgId';
export const TIMEOUT = 'timeout';
export const ENTER = 'Enter';
export const TEXTAREA = 'TEXTAREA';

// Session Storage Keys
export const SESSION_STORAGE_SELECTED_HUB_ID = 'assetron_selected_hub_id';
export const SESSION_STORAGE_SELECTED_MODULE_ID = 'assetron_selected_module_id';

// Organization Limits
export const MAX_ORGANIZATIONS_PER_USER = 5;

// Retry Constants
export const AUTO_RETRY_MAX_ATTEMPTS = 3;
export const AUTO_RETRY_DELAY_MS = 2000;
export const SUPPRESS_SERVER_ERROR_TOAST_HEADER =
  'x-suppress-server-error-toast';

export const MUI_EASING_STANDARD = 'cubic-bezier(0.4, 0, 0.2, 1)';
export const MUI_SLIDE_EASING = {
  enter: MUI_EASING_STANDARD,
  exit: MUI_EASING_STANDARD,
} as const;

export const MUI_DRAWER_SLIDE_PROPS = {
  timeout: TRANSITION_TIMEOUT_MS,
  easing: MUI_SLIDE_EASING,
} as const;

export enum EntitlementStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
}

// eslint-disable-next-line no-shadow
export enum ModuleStatus {
  ACTIVE = 'active',
  COMING_SOON = 'coming_soon',
  INACTIVE = 'inactive',
}

// eslint-disable-next-line no-shadow
export enum NodeTypes {
  ROUTE = 'route',
  GROUP = 'group',
  HUB = 'hub',
}

// Plan System Constants
export const PLAN_IDS = {
  FREE: 'FREE',
  PRO: 'PRO',
  PRO_PLUS: 'PRO_PLUS',
  BUSINESS: 'BUSINESS',
} as const;

export const PLAN_LEVELS = {
  [PLAN_IDS.FREE]: 0,
  [PLAN_IDS.PRO]: 1,
  [PLAN_IDS.PRO_PLUS]: 2,
  [PLAN_IDS.BUSINESS]: 3,
} as const;

export const PLAN_ALIASES = {
  [PLAN_IDS.FREE]: ['free', 'baseplan', 'base-plan', 'base_plan'],
  [PLAN_IDS.PRO]: ['professional', 'pro'],
  [PLAN_IDS.PRO_PLUS]: ['pro-plus', 'professional-plus'],
  [PLAN_IDS.BUSINESS]: ['business'],
} as const;

// Component Types Constants
export const COMPONENT_TYPES = {
  MULTI_SELECT_CHECKBOX: 'MultiSelectCheckbox',
  SUGGEST_MULTI_SELECT: 'SuggestMultiSelect',
} as const;

// Query Params Constants
export const RETURN_URL_QUERY_PARAM = 'returnUrl';
export const SIGN_OUT_QUERY_PARAM = 'signOut';
export const SEARCH_TEXT_QUERY_PARAM = 'text';
export const SEARCH_SCOPE_QUERY_PARAM = 'scope';
export const SEARCH_MODULE_SCOPE_QUERY_PARAM = 'moduleScope';
export const FROM_STRIPE_REDIRECT_QUERY_PARAM = 'FROM_STRIPE_REDIRECT';

// eslint-disable-next-line no-shadow
export enum UserWorkModes {
  ON_SITE = 'On Site',
  REMOTE = 'Remote',
  HYBRID = 'Hybrid',
}

// eslint-disable-next-line no-shadow
export enum ImportUserCsvHeaders {
  NAME = 'name',
  EMAIL = 'email',
  WORK_MODE = 'workMode',
  ENABLE_ACCESS = 'enableAccess',
}

// eslint-disable-next-line no-shadow
export enum UserRoles {
  OWNER = 'Owner',
  ORG_ADMIN = 'Org Admin',
  ASSET_MANAGER = 'Asset Manager',
  USER = 'User',
}

// Auth (FIREBASE) related constants
export const INVALID_CREDENTIAL = 'auth/invalid-credential';
export const ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIAL =
  'auth/account-exists-with-different-credential';
export const TOO_MANY_ATTEMPTS_TRY_LATER = 'auth/too-many-requests';
export const AUTH_LOADING_TIMEOUT = 4000;
export const SNACKBAR_AUTO_HIDE_DURATION = 6000;
export const LOGIN_PROVIDER_GOOGLE = 'google.com';

// Password related constants
export const PASSWORD_MIN_LENGTH = 8;
export const OTP_LENGTH = 6;
export const CACHE_TIME = 1000 * 60 * 60;
export const ASSET_ID_RULE_STALE_TIME = 5 * 60 * 1000; // 5 minutes

// Time Constants
export const SECOND_MS = 1000;
export const MINUTE_MS = 60 * 1000;
export const HOUR_MS = 60 * MINUTE_MS;
export const DAY_MS = 24 * HOUR_MS;

// Local Storage Constants
export const PREVIOUSLY_SELECTED_LOCATION = 'previouslySelectedLocation';
export const LOCATION = 'location';

// Menu Related Constants
export const MENU_COLUMNS_COUNT = 3;

// Key Events Constants
export const TAB_KEY = 'Tab';

// Debounce Constants
export const DEBOUNCE_DELAY = 500;
export const NO_RECORDS = 'NO_RECORDS';

// Transition Constants
export const FULLSCREEN_TRANSITION_ENTER_DURATION = 500;
export const FULLSCREEN_TRANSITION_EXIT_DURATION = 500;

// Data Table Constants
export const ROWS_PER_PAGE_OPTIONS = ['25', '50', '100'];
export const DATA_TABLE_TOTAL_COUNT = 0;
export const DATA_TABLE_PAGE_NUMBER = 1;
export const DATA_TABLE_TOTAL_PAGE_COUNT = 1;

export const DATA_EXPORT_FORMATS = {
  CSV: 'CSV',
  EXCEL: 'EXCEL',
} as const;

export const DEFAULT_EXPORT_PAGE_SIZE = 200;

// Global Search Data Table Constants
export const ROWS_PER_PAGE_OPTIONS_GLOBAL_SEARCH = ['5', '25', '50', '100'];
export const GLOBAL_SEARCH_DEFAULT_SUGGESTION_LIMIT = 5;

// User screen Filter Options
export const USER_FILTER_OPTIONS = {
  Status: [
    { id: 1, name: 'Active' },
    { id: 2, name: 'Deactivated' },
    { id: 3, name: 'Invited' },
    { id: 4, name: 'Invite expired' },
  ],
  Role: [
    { id: 1, name: 'Admin' },
    { id: 2, name: 'User' },
    { id: 3, name: 'Viewer' },
  ],
  'Access to Assetron': [
    { id: 1, name: 'Yes' },
    { id: 2, name: 'No' },
  ],
  Department: [
    { id: 1, name: 'Admin' },
    { id: 2, name: 'Asset Management' },
    { id: 3, name: 'BE Development' },
    { id: 4, name: 'FE Development' },
    { id: 5, name: 'Human Resource' },
    { id: 6, name: 'Product Management' },
    { id: 7, name: 'UI Design' },
    { id: 8, name: 'UX Design' },
  ],
};

export enum AssetronBannerTypes {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

export enum UserStatus {
  ACTIVE = 'Active',
  DEACTIVATED = 'Deactivated',
  INVITED = 'Invited',
  INVITATION_EXPIRED = 'Invitation expired',
  INVITATION_ACCEPTED = 'Invitation accepted',
  NOT_INVITED = 'Not Invited',
}

export const NotesContext = {
  CREATION_NOTE: 'Creation note',
  ALLOCATION_NOTE: 'Allocation note',
};

export const COLUMN_IDS = {
  ASSET_NAME: 'asset-name',
  ASSET_ID: 'asset-id',
  ASSET_TYPE: 'asset-type',
  PARENT_ASSET_TYPE: 'parent-asset-type',
  AVAILABILITY: 'availability',
  STATUS: 'status',
  ALLOCATED_TO: 'allocated-to',
  ALLOCATED_DATE: 'allocated-date',
  USER_NAME: 'user-name',
  USER_ROLES: 'user-roles',
  USER_STATUS: 'user-status',
  SCOPE: 'scope',
  SCOPE_DISPLAY: 'scope-display',
  APPLIES_TO: 'applies-to',
  PREFIX: 'prefix',
  SUFFIX: 'suffix',
  PREVIEW: 'preview',
  NEXT_SEQUENCE: 'next-sequence',
  LAST_CREATED: 'last-created',
  USER_ACCESS_TO_ASSETRON: 'user-access-to-assetron',
  LOCATION_NAME: 'location-name',
  LOCATION_TYPE: 'location-type',
  PARENT_LOCATION: 'parent-location',
  WORK_LOCATION: 'work-location',
  SERIAL_NUMBER: 'serial-number',
  IMPORT_STATUS: 'import-status',
  IMPORT_EMAIL: 'email',
  IMPORT_FULL_NAME: 'full-name',
  IMPORT_ASSET_ID: 'import-asset-id',
  IMPORT_ASSET_TYPE: 'import-asset-type',
  IMPORT_ASSET_NAME: 'import-asset-name',
  IMPORT_SERIAL_NUMBER: 'import-serial-number',
  IMPORT_USER_ACCESS_TO_ASSETRON: 'import-user-access-to-assetron',
  IMPORT_USER_WORK_MODE: 'import-user-work-mode',
  ACTION: 'action',
  EDIT_ACTION: 'editAction',
  DOMAIN: 'domain',
  VERIFICATION_STATUS: 'verification-status',
  AUTO_ADD_DOMAIN_USERS: 'auto-add-users',
  ASSIGNEE_EMAIL: 'assignee-email',
  DOCUMENT_NAME: 'name',
  DOCUMENT_TYPE: 'document-type',
  UPLOADED_BY: 'uploaded-by',
  DOCUMENT_ACTIONS: 'document-actions',
  WORK_ITEM_ID: 'work-item-id',
  TITLE: 'title',
  ASSIGNEE: 'assignee',
};

// Edit user details constants
export const BASIC_DETAILS = 'Basic';
export const ORGANIZATIONAL_DETAILS = 'Organizational';
export const ROLES_AND_ACCESS = 'Roles';

// Dialog Mode Constants
export const DIALOG_MODE = {
  EDIT: 'edit',
  CREATE: 'create',
} as const;

// Filter labels
export const ASSET_TYPE = 'Asset type';
export const STATUS = 'Status';
export const AVAILABILITY = 'Availability';
export const ALLOCATED_TO = 'Allocated to';

// header cell widths needs to be fixed but not decided to put them here or in backend
export const DATA_TABLE_HEADERS = [
  { id: COLUMN_IDS.ASSET_NAME, label: 'ASSET NAME' },
  { id: COLUMN_IDS.ASSET_ID, label: 'ASSET ID', width: '144px' },
  { id: COLUMN_IDS.ASSET_TYPE, label: 'ASSET TYPE', width: '126px' },
  { id: COLUMN_IDS.AVAILABILITY, label: 'AVAILABILITY', width: '133px' },
  { id: COLUMN_IDS.STATUS, label: 'STATUS', width: '138px' },
  { id: COLUMN_IDS.ALLOCATED_TO, label: 'ALLOCATED TO', width: '160px' },
  { id: COLUMN_IDS.LOCATION_NAME, label: 'LOCATION', width: '144px' },
];

export const SEARCH_ASSET_TABLE_HEADERS = [
  { id: COLUMN_IDS.ASSET_NAME, label: 'ASSET NAME' },
  { id: COLUMN_IDS.ASSET_ID, label: 'ASSET ID', width: '144px' },
  { id: COLUMN_IDS.ASSET_TYPE, label: 'ASSET TYPE', width: '129px' },
  {
    id: COLUMN_IDS.AVAILABILITY,
    label: 'AVAILABILITY',
    width: '134px',
  },
  {
    id: COLUMN_IDS.ALLOCATED_TO,
    label: 'ALLOCATED TO',
    width: '160px',
  },
  { id: COLUMN_IDS.LOCATION_NAME, label: 'LOCATION', width: '200px' },
];
// User Table Headers
export const USER_TABLE_HEADERS = [
  { id: COLUMN_IDS.USER_NAME, label: 'NAME' },
  { id: COLUMN_IDS.USER_ROLES, label: 'ROLES' },
  { id: COLUMN_IDS.USER_STATUS, label: 'STATUS' },
];

export const ASSET_ID_RULES_HEADERS = [
  {
    id: COLUMN_IDS.SCOPE_DISPLAY,
    label: 'Scope',
    width: 'calc(100% / 8)',
  },
  {
    id: COLUMN_IDS.APPLIES_TO,
    label: 'Applies To',
    width: 'calc(100% / 8)',
  },
  {
    id: COLUMN_IDS.PREFIX,
    label: 'Prefix',
    width: 'calc(100% / 8)',
  },
  {
    id: COLUMN_IDS.SUFFIX,
    label: 'Suffix',
    width: 'calc(100% / 8)',
  },
  {
    id: COLUMN_IDS.NEXT_SEQUENCE,
    label: 'Next Sequence',
    width: 'calc(100% / 8)',
  },
  {
    id: COLUMN_IDS.PREVIEW,
    label: 'Preview',
    width: 'calc(100% / 8)',
  },
  {
    id: COLUMN_IDS.LAST_CREATED,
    label: 'Last Created',
    width: 'calc(100% / 8)',
  },
  {
    id: COLUMN_IDS.ACTION,
    label: 'Actions',
    width: '92px',
    align: 'center',
    flex: 0,
  },
];

export const OFFICE_LOCATIONS_HEADERS = [
  { id: COLUMN_IDS.LOCATION_NAME, label: 'Location Name' },
  { id: COLUMN_IDS.LOCATION_TYPE, label: 'Location Type' },
  { id: COLUMN_IDS.PARENT_LOCATION, label: 'Parent Location' },
  {
    id: COLUMN_IDS.ACTION,
    label: 'Actions',
    width: '92px',
    align: 'center',
    flex: 0,
  },
];
export const STORAGE_LOCATIONS_HEADERS = [
  { id: COLUMN_IDS.LOCATION_NAME, label: 'Location Name' },
  { id: COLUMN_IDS.LOCATION_TYPE, label: 'Location Type' },
  { id: COLUMN_IDS.PARENT_LOCATION, label: 'Parent Location' },
  { id: COLUMN_IDS.WORK_LOCATION, label: 'Work Location' },
  {
    id: COLUMN_IDS.ACTION,
    label: 'Actions',
    width: '92px',
    align: 'center',
    flex: 0,
  },
];

export const ASSET_TYPES_HEADERS = [
  { id: COLUMN_IDS.ASSET_TYPE, label: 'Asset Type' },
  { id: COLUMN_IDS.PARENT_ASSET_TYPE, label: 'Parent' },
  {
    id: COLUMN_IDS.ACTION,
    label: 'Actions',
    width: '92px',
    align: 'center',
    flex: 0,
  },
];
export const DOMAIN_SETTINGS_HEADERS = [
  { id: COLUMN_IDS.DOMAIN, label: 'Domain', width: 'calc(100% / 3)' },
  {
    id: COLUMN_IDS.VERIFICATION_STATUS,
    label: 'Verification Status',
    width: 'calc(100% / 3)',
  },
  {
    id: COLUMN_IDS.AUTO_ADD_DOMAIN_USERS,
    label: 'Automatically Add Domain Users to Organization',
    width: 'calc(100% / 3)',
  },
];

export const TRACKERS_AND_IDENTIFIERS_HEADERS_EDITABLE = [
  { id: 'asset-id-type', label: 'Identifiers', width: '128px' },
  { id: 'value', label: EMPTY_STRING, isEditable: true },
];

export const TRACKERS_AND_IDENTIFIERS_HEADERS_NON_EDITABLE = [
  { id: 'asset-id-type', label: 'Identifiers', width: '128px' },
  { id: 'value', label: EMPTY_STRING },
];

export const TRACKERS_HEADING = [
  {
    id: 'tracker-card',
    label: 'TRACKERS',
  },
];

export const WINDOWS = 'Windows';
export const MACOS = 'macOS';
export const LINUX = 'Linux';

export const TECHNICAL_DETAILS_HEADERS = [
  { id: 'asset-id-type', label: 'General', width: '128px' },
  { id: 'value', label: EMPTY_STRING, width: '480px' },
];

export const IMPORT_ASSETS_HEADERS = [
  { id: COLUMN_IDS.IMPORT_ASSET_ID, label: 'ASSET ID', width: '200px' },
  { id: COLUMN_IDS.IMPORT_ASSET_TYPE, label: 'ASSET TYPE', width: '144px' },
  { id: COLUMN_IDS.IMPORT_ASSET_NAME, label: 'ASSET NAME' },
  {
    id: COLUMN_IDS.IMPORT_SERIAL_NUMBER,
    label: 'SERIAL NUMBER',
    width: '200px',
  },
  {
    id: COLUMN_IDS.ASSIGNEE_EMAIL,
    label: 'ASSIGNEE EMAIL',
    width: '200px',
  },
  { id: COLUMN_IDS.IMPORT_STATUS, label: 'STATUS' },
];

export const IMPORT_USERS_HEADERS = [
  { id: COLUMN_IDS.IMPORT_FULL_NAME, label: 'FULL NAME', width: '341.67px' },
  { id: COLUMN_IDS.IMPORT_EMAIL, label: 'EMAIL', width: '341.67px' },
  { id: COLUMN_IDS.IMPORT_USER_WORK_MODE, label: 'WORK MODE', width: '191px' },
  { id: COLUMN_IDS.IMPORT_STATUS, label: 'STATUS', width: '341.67px' },
];

export const IMPORT_LOCATIONS_HEADERS = [
  { id: COLUMN_IDS.LOCATION_NAME, label: 'LOCATION NAME', width: '240px' },
  { id: COLUMN_IDS.LOCATION_TYPE, label: 'LOCATION TYPE', width: '220px' },
  { id: COLUMN_IDS.PARENT_LOCATION, label: 'PARENT LOCATION', width: '220px' },
  { id: COLUMN_IDS.WORK_LOCATION, label: 'WORK LOCATION', width: '220px' },
  { id: COLUMN_IDS.IMPORT_STATUS, label: 'STATUS', width: '220px' },
];

export const MY_ASSETS_TABLE_HEADERS = [
  { id: COLUMN_IDS.ASSET_TYPE, label: 'ASSET TYPE', width: 'calc(100% / 6)' },
  { id: COLUMN_IDS.ASSET_ID, label: 'ASSET ID', width: 'calc(100% / 6)' },
  { id: COLUMN_IDS.ASSET_NAME, label: 'ASSET NAME', width: 'calc(100% / 6)' },
  {
    id: COLUMN_IDS.SERIAL_NUMBER,
    label: 'SERIAL NUMBER',
    width: 'calc(100% / 6)',
  },
  {
    id: COLUMN_IDS.ALLOCATED_DATE,
    label: 'ALLOCATED DATE',
    width: 'calc(100% / 6)',
  },
  { id: COLUMN_IDS.STATUS, label: 'STATUS', width: 'calc(100% / 6)' },
];

export const MY_ASSETS_ENTITY_ID = 'my_assets';
export const USER_FILTER_FIELD = 'allocated_to_assetron_user_id';
export const MY_ASSETS_ALLOCATED_DATE_KEYS = ['checked_out_date'];

export const DOCUMENTS_TABLE_HEADERS = [
  { id: COLUMN_IDS.DOCUMENT_NAME, label: 'NAME' },
  { id: COLUMN_IDS.DOCUMENT_TYPE, label: 'TYPE', width: '144px' },
  { id: COLUMN_IDS.UPLOADED_BY, label: 'UPLOADED BY', width: '160px' },
  { id: COLUMN_IDS.DOCUMENT_ACTIONS, label: 'ACTIONS', width: '106px' },
];
export const ALL_WORK_TABLE_HEADERS = [
  { id: COLUMN_IDS.WORK_ITEM_ID, label: 'Work Item ID', width: '144px' },
  { id: COLUMN_IDS.TITLE, label: 'TITLE' },
  { id: COLUMN_IDS.STATUS, label: 'STATUS', width: '138px' },
  { id: COLUMN_IDS.ASSIGNEE, label: 'ASSIGNEE', width: '160px' },
];

export const WORKITEM_DISPLAY_NAME_OVERRIDES = {
  number: 'Request ID',
  title: 'Title',
  priority: 'Priority',
  status: 'Status',
} as const;

export const WORKITEM_OPEN_STATUS_CANDIDATES = [
  'new',
  'triage',
  'in progress',
  'waiting',
  'scheduled',
] as const;

export const WORKITEM_CLOSED_STATUS_CANDIDATES = [
  'closed',
  'resolved',
] as const;

// Work Items list default sort
export const WORKITEMS_DEFAULT_ORDER_BY = 'createdAt asc' as const;

// Service tab (Asset detail) Work Items table constants
export const SERVICE_TAB_WORKITEMS_VIEW_ID = 'workitems' as const;

export const SERVICE_TAB_WORKITEM_COLUMNS = [
  'number',
  'title',
  'status',
  'priority',
] as const;

export const SERVICE_TAB_WORKITEM_HIDDEN_COLUMNS = ['id'] as const;

export const SERVICE_TAB_ROWS_PER_PAGE_OPTIONS = [
  '5',
  '10',
  '25',
  '50',
] as const;

// Pagination Constants
export const BOUNDRY_COUNT = 1;
export const SIBLING_COUNT = 1;
export const ELLIPSIS_CONTENT = '...';
export const PENDING_REPAIR = 'Pending Repair';

export const USABILITY_CODE: Record<string, string> = {
  'Yes, still usable': 'usable',
  'Yes, usable with reduced capability': 'capability_reduced',
  'No, not usable': 'not_usable',
};

// Asset Category Constants
export const IT = 'IT';
export const HOME = 'IT Home';
export const HARDWARE = 'Hardware';
export const ALL_ASSETS = 'All assets';
export const ALL_SEARCH_SCOPES = 'all';

export enum GlobalSearchModuleScope {
  ASSET_MANAGEMENT = 'assetManagement',
  SERVICE_MANAGEMENT = 'serviceManagement',
}

export enum GlobalSearchEntityScope {
  ASSETS = 'assets',
  USERS = 'users',
  WORK_ITEMS = 'workItems',
  SERVICE = 'service',
}

export const ASSET_ID = 'AssetId';

// Setting Category Constants
export const ALLOW_MANUAL_EDIT = 'AllowManualEdit';

// CSV file Related constants
export const DEFAULT_CSV_FILE_NAME = 'sample_template.csv';

// File Upload Constants
export const HEADERS_MISMATCH_ERROR = 'HEADERS_MISMATCH';

export const API_ERROR_CODES = {
  BAD_REQUEST: 400,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
};

// Work location constants
// eslint-disable-next-line no-secrets/no-secrets
export const DEFAULT_WORK_LOCATION_QUERY = "?$filter=LocationType eq 'on-site'";

// Expandable Filters Constants
export const DEFAULT_VISIBLE_OPTIONS_COUNT = 5;
export const DEFAULT_SEARCH_RESULTS_PAGE_SIZE = 5;
export const SEARCH_SESSION_ID = 'searchSessionId';
export const SUGGEST_SESSION_ID = 'suggestSessionId';
export const ANALYTICS_API_MAX_RETRIES = 3;

// BASE64 ENCODED PREFIXES
export const BASE64_PREFIX_SVG = `data:image/svg+xml;base64,`;

// Marketing Site Constants
export const ASSETRON_MARKETING_SITE_CONTACT_US_URL = `${ASSETRON_MARKETING_SITE_URL}/contact-us`;
export const ASSETRON_MARKETING_SITE_PRICING_PAGE_URL = `${ASSETRON_MARKETING_SITE_URL}/pricing`;

export const ORG_NAME = 'orgName';

// Role constants
export const USER_ROLES = {
  OWNER: 'Owner',
  ORG_ADMIN: 'Org Admin',
  ASSET_MANAGER: 'Asset Manager',
  USER: 'User',
};
export const HIGHER_LEVEL_ROLES = [
  USER_ROLES.OWNER,
  USER_ROLES.ORG_ADMIN,
  USER_ROLES.ASSET_MANAGER,
] as const;

// For user status
export const USER_STATUS_INVITATION_EXPIRED = 'Invitation Expired';
export const USER_STATUS_INVITED = 'Invited';
export const USER_STATUS_NOT_INVITED = 'Not Invited';

// For user import/validation API response status (lowercase)
export enum UserStatusResponse {
  ACTIVE = 'active',
  INVITED = 'invited',
  NOT_INVITED = 'not_invited',
  NOT_EXIST = 'not_exist',
}

// For Dummy reCAPTCHA token
export const DUMMY_RECAPTCHA_TOKEN = 'dummyrecaptcha-token';

// For domain verification status
export const DOMAIN_VERIFICATION_STATUS = {
  VERIFIED: 'Verified',
  VERIFICATION_PENDING: 'Verification Pending',
};

// For user view modes
export const USER_VIEW = 'userView';
export const ADMIN_VIEW = 'admin';
export const USER_ONLY_VIEW = 'user-only';

// Subscription Status Constants
export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  TRIAL: 'trial',
} as const;

// Abort Error Constants
export const ABORT_ERROR_NAME = 'AbortError';
export const ABORT_ERROR_CODE = 'ERR_CANCELED';

// File types for upload documents
export const FILE_TYPES = {
  AUDIO: ['mp3', 'wav', 'ogg', 'aac', 'm4a'],
  VIDEO: ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv'],
  IMAGE: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'],
  PDF: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'rtf', 'md'],
};

export const FILE_STATUS = {
  IDLE: 'idle',
  QUEUED: 'queued',
  UPLOADING: 'uploading',
  PAUSED: 'paused',
  SUCCESS: 'success',
  FAILED: 'failed',
  CANCELED: 'canceled',
};

export const DOCUMENT_TELEMETRY = {
  DOCUMENT_SIZE: 'documentSize',
  DOCUMENT_TYPE: 'documentType',
  DOCUMENT_NAME: 'documentName',
  DOCUMENT_KEY: 'documentKey',
  BLOB_PATH: 'blobPath',
  DURATION_MS: 'durationMs',
};

export const DOCUMENT_TELEMETRY_EVENTS = {
  UPLOAD_COMPLETED: 'DocumentUploadCompleted',
  UPLOAD_FAILED: 'DocumentUploadFailed',
  UPLOAD_PAUSED: 'DocumentUploadPaused',
  UPLOAD_RESUMED: 'DocumentUploadResumed',
  UPLOAD_CANCELED: 'DocumentUploadCanceled',
  CHUNK_UPLOAD_FAILED: 'DocChunkFailed',
};

export const UPLOAD_CONFIGURATION = {
  CHUNK_THRESHOLD: 4 * 1024 * 1024, // 4MB - threshold for chunked upload
  BLOCK_SIZE: 4 * 1024 * 1024, // 4MB - size of each chunk
  CHUNKED_CONCURRENCY: 3, // Number of concurrent chunks for large files
  SINGLE_FILE_CONCURRENCY: 1, // Concurrency for small files
  MAX_RETRY_ATTEMPTS: 1, // Maximum number of retry attempts
  RETRY_TIMEOUT_MS: 5000, // 5 second timeout per try
  RETRY_DELAY_MS: 1000, // 1 second delay between retries
};

export enum FeatureLevels {
  NONE = 'none',
  BASIC = 'basic',
  ADVANCED = 'advanced',
}

export const UNLIMITED_VALUE = 'unlimited' as const;

export const LEVEL_ORDER = {
  basic: 1,
  advanced: 2,
} as const;

// Plan Entitlement Types
export const FEATURE_ACCESS = 'access';
export const FEATURE_USE_WITHIN_LIMIT = 'useWithinLimit';
export const FEATURE_USE_LEVEL = 'useLevel';

// eslint-disable-next-line no-shadow
export enum PlanRestrictionCardVariant {
  DEFAULT = 'default',
  ENHANCED = 'enhanced',
}

// eslint-disable-next-line no-shadow
export enum DocumentUploadEntityType {
  ASSET = 'Asset',
  WORK_ITEM = 'WorkItem',
}

// Generic Status Constants for AssetTrackers
export const TRACKER_STATUS = {
  PENDING: 'pending',
  INACTIVE: 'inactive',
  PAIRED: 'paired',
  CONNECTED: 'connected',
};

export const TRACKERS_LABEL_NAMES = {
  SUCCESS: 'Connected',
  PENDING: 'Pending',
  INACTIVE: 'Connect',
};

export const TRACKING_AGENT = 'tracking_agent';

export const TRACKING_AGENT_STATUS = {
  ONLINE: 'online',
  OFFLINE: 'offline',
} as const;

export const TRACKING_AGENT_STATUS_LABELS: Record<
  keyof typeof TRACKING_AGENT_STATUS,
  string
> = {
  ONLINE: 'Online',
  OFFLINE: 'Offline',
};

export const LOCK_ICON_SIZE = 14;

export const ORG_NAME_MAP_STORAGE_KEY = 'orgNamesById';

// Tracking Agent Download URLs
export const DEFAULT_TRACKING_AGENT_PACKAGE_BASE_URL =
  'https://assetron-packages-h0gcccg4gdb4bedm.z02.azurefd.net';
export const DEFAULT_TRACKING_AGENT_MACOS_PKG_URL = `${DEFAULT_TRACKING_AGENT_PACKAGE_BASE_URL}/macos/0.1.1/assetron-agent-0.1.1-osx-x64.pkg`;
export const DEFAULT_TRACKING_AGENT_INSTALL_SCRIPT_URL = `${DEFAULT_TRACKING_AGENT_PACKAGE_BASE_URL}/macos/download-agent.sh`;

// Generic Entity Constants for DynamicEntityView
export const ENTITY_CONSTANTS = {
  REPORTS: {
    entity: 'reports',
    entityIdParam: 'reportId',
  },
  WORK_ITEMS: {
    entity: 'workItems',
    entityIdParam: 'workItemId',
  },
  WORKITEM_LIST_VIEWS: {
    entity: 'workItemListViews',
    entityIdParam: 'workItemListViewId',
  },
  ASSET_LIST_VIEWS: {
    entity: 'assetListViews',
    entityIdParam: 'assetListViewId',
  },
} as const;

// Default Pagination Constants
export const DEFAULT_PAGINATION = {
  totalCount: 0,
  pageNumber: 1,
  pageSize: 100,
  totalPageCount: 0,
} as const;

export const RETRY_CONFIGURATION = {
  MAX_RETRY_ATTEMPTS: 5, // Maximum number of retry attempts
  RETRY_DELAY_MS: 3000, // 1 second delay between retries
};
// Defaults for inline text edit
export const DEFAULT_TYPOGRAPHY_VARIANT = 'heading_20_medium';
export const DEFAULT_MIN_ROWS_INLINE_TEXT_EDIT = 1;
export const DEFAULT_MAX_ROWS_INLINE_TEXT_EDIT = 2;

export enum DIRECTLINE_ACTION {
  CONNECT_FULFILLED = 'DIRECT_LINE/CONNECT_FULFILLED',
  POST_ACTIVITY = 'DIRECT_LINE/POST_ACTIVITY',
}

export enum WEBCHAT_STORE_ACTION {
  SEND_EVENT = 'WEB_CHAT/SEND_EVENT',
  SEND_MESSAGE = 'WEB_CHAT/SEND_MESSAGE',
  SEND_POST_BACK = 'WEB_CHAT/SEND_POST_BACK',
  REVA_SUPPORT_HANDOFF = 'REVA_SUPPORT_HANDOFF',
  CREATE_WORK_ITEM = 'CREATE_WORK_ITEM',
}

export enum ASSISTANT_CHAT_EVENT {
  START_CONVERSATION = 'startConversation',
}

export enum WEBCHAT_ACTIVITY_TYPE {
  EVENT = 'event',
  MESSAGE = 'message',
}

export enum WEBCHAT_ACTION_PAYLOAD_TYPE {
  EVENT = 'event',
}

export const DEFAULT_CARD_GRID = { xs: 12, sm: 6, md: 4, lg: 3, xl: 3 };

export enum SEARCH_SCOPE {
  ASSETS = 'assets',
  USERS = 'users',
  WORK_ITEMS = 'workItems',
  SERVICE = 'service',
  ASSET_MANAGEMENT = 'assetManagement',
  SERVICE_MANAGEMENT = 'serviceManagement',
}
export const IMPORT_ASSET_BATCH_SIZE = 50;
export const IMPORT_USER_BATCH_SIZE = 25;

// Views related Query Params
export const REPORTS_ENTITY_QUERY_PARAM = 'reports';

// Workitem details
export const NONE_ASSIGNEE_ID = 'None';
export const WORK_ITEM_DATE_FORMAT = 'D MMM, YYYY [at] h:mm A';

export const ASSET_TYPE_SCOPE = 'ASSET_TYPE';
export const WORK_LOCATION_SCOPE = 'WORK_LOCATION';
export const GLOBAL_SCOPE = 'GLOBAL';
